import { FC } from "react";
import { Popover, PopoverOrigin } from "@mui/material";
import Stack from "@mui/material/Stack";
import { FilterTreeChip } from "@/components/pages/common/filters-tree/filters-disabled-view/components/FilterTreeChip";

interface FilterTreeDisabledValueAutocompletePopover {
  open: boolean;
  onClose(): void;
  filterValue: string[];
  anchor: HTMLElement | null;
  optionsMap: Record<string, string>;
}

export const FilterTreeDisabledValueAutocompletePopover: FC<
  FilterTreeDisabledValueAutocompletePopover
> = ({ open, anchor, onClose, optionsMap, filterValue }) => {
  return (
    <Popover
      open={open}
      anchorEl={anchor}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
    >
      <Stack
        p={1}
        gap={1}
        maxWidth={400}
        flexWrap="wrap"
        direction="row"
        maxHeight="45dvh"
      >
        {filterValue.map((value) => (
          <FilterTreeChip key={value} title={optionsMap?.[value] ?? value} />
        ))}
      </Stack>
    </Popover>
  );
};

const anchorOrigin: PopoverOrigin = {
  vertical: "bottom",
  horizontal: "left",
};

const transformOrigin: PopoverOrigin = {
  vertical: "top",
  horizontal: "left",
};
